import { Link } from 'gatsby'
import React from 'react'
import Icon from '../icons'
// import { cn } from '../../lib/helpers'
import styled from '@emotion/styled'
import tw from 'tailwind.macro'
import { GatsbyImage } from 'gatsby-plugin-image'
import logohireright from '../../images/logo-hireright.svg'

// import styles from './micrositeHeader.module.css'

const Header = (props) => {
  const { showNav, onHideNav, onShowNav,coBrandingImage } = props
  const siteUrl = props.slug.current
  const homeUrl = 'https://www.hireright.com'

  // component styles
  const NavRoot = tw.header`
    bg-white py-2
  `
  const NavWrapper = tw.div`
    flex flex-wrap items-center justify-between  
  `
  const NavLogoLink = styled(Link)`
    ${tw`flex items-center text-black no-underline`};
  `
  const NavSection = styled.nav`
    ${tw`w-full px-4 pt-3 pb-5 mt-4 bg-white md:block md:flex md:items-center md:w-auto shadow-lgFull md:shadow-none`};
    transition: all 0.3s ease-in-out;
    display: ${(props) => (props.showNav ? 'block' : 'none')};
  `
  const NavLink = styled(Link)`
    ${tw`block mt-3 ml-2 font-bold text-black no-underline md:inline-block md:mt-0 md:ml-10 hover:text-hr-red hover:underline text-normal`};
    transition: all 0.3s ease-in-out;
  `
  const NavButton = styled.button`
    ${tw`flex items-center block px-3 py-2 text-3xl text-black bg-transparent border-none rounded outline-none md:hidden`};
  `
  return (
    <NavRoot>
      <NavWrapper>
        <NavLogoLink to={homeUrl}>
          <img src={logohireright} alt="HireRight logo" height="40px" width="200px" />

          {coBrandingImage?.asset && (
            <>
              <span className="mx-5 text-3xl text-gray-500"> | </span>
              <GatsbyImage               
                image={coBrandingImage.asset.gatsbyImageData}
                alt={coBrandingImage?.alt}
                style={{ height: `50px`, width: `120px` }}
                imgStyle={{ height: `50px`, width: `inherit`, objectFit: 'scale-down' }}
                placeholderStyle={{ height: `50px`, width: `inherit`, objectFit: 'scale-down' }}
              />
            </>
          )}
        </NavLogoLink>

        <NavButton onClick={showNav ? onHideNav : onShowNav}>
          <Icon symbol="hamburger" />
        </NavButton>

        <NavSection showNav={showNav}>
          {props.nav_options && props.nav_options.navPages && (
            <>
              <NavLink to={`/${siteUrl}/`}>Home</NavLink>
              {props.nav_options.navPages.includes('packages') && (
                <NavLink
                  to={
                    props.nav_options.standalonePages &&
                    props.nav_options.standalonePages.includes('packages')
                      ? `/${siteUrl}/packages`
                      : `/${siteUrl}/#packages`
                  }
                >
                  Packages
                </NavLink>
              )}
              {props.nav_options.navPages.includes('faq') && (
                <NavLink
                  to={
                    props.nav_options.standalonePages &&
                    props.nav_options.standalonePages.includes('faq')
                      ? `/${siteUrl}/faq`
                      : `/${siteUrl}/#faq`
                  }
                >
                  FAQ
                </NavLink>
              )}
              {props.nav_options.navPages.includes('resources') && props.resources && (
                <NavLink to={`/${siteUrl}/resources`}>Resources</NavLink>
              )}
              {props.nav_options.navPages.includes('about_us') && (
                <NavLink
                  to={
                    props.nav_options.standalonePages &&
                    props.nav_options.standalonePages.includes('about_us')
                      ? `/${siteUrl}/about`
                      : `/${siteUrl}/#about`
                  }
                >
                  About Us
                </NavLink>
              )}
              {props.nav_options.navPages.includes('contact_us') && (
                <NavLink
                  to={
                    props.nav_options.standalonePages &&
                    props.nav_options.standalonePages.includes('contact_us')
                      ? `/${siteUrl}/contact`
                      : `/${siteUrl}/#contact`
                  }
                >
                  Contact Us
                </NavLink>
              )}
            </>
          )}
        </NavSection>

        {/* <NavSection showNav={showNav}> 
            <NavLink to={siteUrl} >Home</NavLink>
            {props.packages &&
              <NavLink
               to={props.standalone_packages ? `/${siteUrl}/packages` : `/${siteUrl}/#packages`}> 
               Packages
               </NavLink>
            }
            {props.faqs &&
              <NavLink 
                to={props.standalone_faq ? `/${siteUrl}/faq` : `/${siteUrl}/#faq`}>
                FAQ
              </NavLink>
            }
              <NavLink 
                to={props.standalone_about_us ? `/${siteUrl}/about` : `/${siteUrl}/#about`}>
                About Us
              </NavLink>
              <NavLink 
                to={props.standalone_contact_us ? `/${siteUrl}/contact` : `/${siteUrl}/#contact`}>
                Contact Us
              </NavLink>
        </NavSection>   */}
      </NavWrapper>
    </NavRoot>
  )
}

export default Header
